import { render } from "./actual-old-cost-summary.vue?vue&type=template&id=2d6305d6"
import script from "./actual-old-cost-summary.vue?vue&type=script&lang=js"
export * from "./actual-old-cost-summary.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__